<template>
  <div class="content">
    <van-form @submit="signUp">
      <div class="appointment_number">
        <div class="box">
          <div style="padding:20px;display:flex;align-items:center">
            <img style="width:30px;height:30px" src="@/assets/image/batchSignUp/appointment_icon.png" alt="">
            <span style="color:white;font-size:16px;margin-left:10px">申请预约人数</span>
          </div>
          <div style="padding:20px;margin-top:-28px;display:flex;align-items:center;justify-content:space-between">
            <div style="color:white;font-size:20px">理论：{{theoryNumber}}</div>
            <div style="color:white;font-size:20px">实操：{{operaNumber}}</div>
          </div>
        </div>
      </div>
      <template v-if="isSignUpTheoryExam">
        <div class="title">
          预约理论考试
        </div>
        <div class="subscribe_time">
          <div class="appoint-title">预约考试地点 <span style="color:red">*</span></div>
          <el-select style="width:100%" v-model="theoryAddress" placeholder="请选择考试地点">
            <el-option
              v-for="(item,index) in examAddress"
              :key="index"
              :label="item.examAddressName"
              :value="item.id"
              >
            </el-option>
          </el-select>
          <div class="appoint-title" style="margin-top:20px">预约考试时间 <span style="color:red">*</span></div>
          <div class="block">
            <el-cascader
              placeholder="请选择考试时间"
              style="width:100%"
              separator=' '
              popper-class="train-tree"
              v-model="theorySelectExamTime"
              :options="theoryExamTime"
            >
            </el-cascader>
          </div>
        </div>
      </template>
      <template v-if="isSignUpOperaExam">
        <div class="title">
          预约实操考试
        </div>
        <div class="subscribe_time">
          <div class="appoint-title">预约考试地点 <span style="color:red">*</span></div>
          <el-select style="width:100%" v-model="operaAddress" placeholder="请选择考试地点">
            <el-option
              v-for="(item,index) in examAddress"
              :key="index"
              :label="item.examAddressName"
              :value="item.id"
              >
            </el-option>
          </el-select>
          <div class="appoint-title" style="margin-top:20px">预约考试时间 <span style="color:red">*</span></div>
          <div class="block">
            <el-cascader
              placeholder="请选择考试时间"
              style="width:100%"
              separator=' '
              popper-class="train-tree"
              v-model="operaSelectExamTime"
              :options="operaExamTime"
            >
            </el-cascader>
          </div>
        </div>
      </template>
      <div class="footer">
        <van-button block type="info" native-type="submit">下一步</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      theoryNumber: 0,
      operaNumber: 0,
      appraisalId: '',
      examAddress: [], //考试地点数据
      theoryAddress: '', //理论考试地点
      operaAddress: '',  //实操考试地点
      theoryExamTime: [], //理论考试时间
      theorySelectExamTime: [],
      operaExamTime: [], //实操考试时间
      operaSelectExamTime: [],
    }
  },
  computed: {
    isSignUpTheoryExam: function() { //是否报名的理论
      return this.theoryNumber > 0
    },
    isSignUpOperaExam: function() {  //是否报名的实操
      return this.operaNumber > 0
    },
  },
  watch: {
    theoryAddress: function() {
      this.theorySelectExamTime = []
      this.fetchExamTime('theory',this.theoryAddress)
    },
    operaAddress: function() {
      this.operaSelectExamTime = []
      this.fetchExamTime('operation', this.operaAddress)
    },
  },
  created() {
    this.getSignUpNumber()
    this.getAddress()
  },
  methods: {
    getSignUpNumber: function() { //获取申请人数
      const params = {
        ids : this.$route.query.ids
      }
      this.$http.get('/registration/number/subject', {params}).then(res => {
        if(res.data.success){
          let data = res.data.data
          this.theoryNumber = data.theoryNumber || 0
          this.operaNumber = data.operaNumber || 0
          this.appraisalId = data.appraisalId
        }
      })
    },

    getAddress: function() {    //获取考试地点
      this.$http.get("/registration/address").then(res => {
        if(res.data.success){
          this.examAddress = res.data.data
        }
      }).catch(() => {
        this.$message({
          message: "获取考试地点失败",
          type: "warning",
        })
      })
    },

    fetchExamTime: function(subject,addressId) {  //获取考试时间
      const params = {
        appraisalId: this.appraisalId,
        ids : this.$route.query.ids,
        addressId: addressId,
        subject: subject
      }
      this.$http.get("/registration/time", {params}).then((res) => {
        if (res.data.success) {
          let list = res.data.data.timeList
          list.forEach(res => {
            res.children.forEach(childRes =>{
              childRes.value = childRes.examId
              childRes.label = childRes.period + `（剩余${childRes.remainNumber < 0 ? 0 : childRes.remainNumber}人）`
              if(childRes.remainNumber <= 0 ){
                childRes.disabled = true
              }
            })
          })
          if(subject === 'theory'){
            this.theoryExamTime = list
          }else {
            this.operaExamTime = list
          }
        }else{
          this.$message({
            message: res.data.msg,
            type: "warning",
          })
        } 
      })
    },
    

    signUp: function() {  //报名
      if(this.isSignUpTheoryExam){
        if(!this.theoryAddress){
          this.$message({
            message: "请选择理论考试预约地点",
            type: "warning",
          })
          return
        }
        if(this.theorySelectExamTime.length === 0){
          this.$message({
            message: "请选择理论考试预约时间",
            type: "warning",
          })
          return
        }
      }
      if(this.isSignUpOperaExam){
        if(!this.operaAddress){
          this.$message({
            message: "请选择实操考试预约地点",
            type: "warning",
          })
          return
        }
        if(this.operaSelectExamTime.length === 0){
          this.$message({
            message: "请选择实操考试预约时间",
            type: "warning",
          })
          return
        }
      }
      let params = {
        ids: this.$route.query.ids,
        theAddressId: this.theoryAddress,
        opeAddressId: this.operaAddress,
        theExamId: this.theorySelectExamTime[1] || '',
        opeExamId: this.operaSelectExamTime[1] || ''
      }
      let text = `本次可成功预约理论考试${this.theoryNumber}人，实操考试${this.operaNumber}人，是否确认预约并交费?`
      this.$dialog.confirm({
        title: '提示',
        message: text,
        confirmButtonColor: '#54B0FB',
        confirmButtonText:'确定',
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '提交数据中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        this.$http.post('/registration/signUp', params).then(res => {
          if(res.data.success){ 
            this.$router.push(`/order/pay/${res.data.data.orderId}`)
          }else{
            this.$message({
              message: res.data.msg,
              type: "warning",
            })
          }
        }).finally(() => {
          loading.close()
        })
      })
    },
  },
}
</script>

<style scoped lang="less">
*{
  box-sizing: border-box;
}
.content {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 30px;
  position: relative;
  width: 100%;
  height: 100vh;
  background-color: @whitee;
  @tree-select-item-active-color: blue
}
.appointment_number{
  width: 100%;
  height: 260px;
  padding: 10px;
  box-sizing: border-box;
  .box{
    width: 100%;
    height: 100%;
    background: url('~@/assets/image/batchSignUp/appointment_background.png');
    background-size: 100% 100%;
  }
}
.title {
  margin-top: 30px;
  padding-left: 40px;
  line-height: 100px;
  width: 100%;
  height: 100px;
  font-size: 36px;
  background: #F1F1F1;
  font-weight: bold;
}
.subscribe_time {
  padding: 30px;
  background-color: #fff;
}
.appoint-title {
  height: @textgao;
  line-height: @textgao;
  margin-bottom: 20px;
  margin-top: 18px;
  margin-left: 8px;
}
.footer {
  position: absolute;
  bottom: 20px;
  margin-left:30px;
  width: 690px;
  height: 90px;
  background: #54B0FB;
  border-radius: 8px;
}

.van-sidebar-item--select::before{
  background: #2590fe;
}
.van-tree-select__item--active{
  color: #2590fe;
}
</style>
<style lang='less'>
.train-tree{
  .el-cascader-node{
    padding: 0 !important;
  }
  .el-cascader-menu{
    min-width: 155px !important;
  }
  .el-icon-check{
    display: none;
  }
}
</style>
